export function openGameMathPage(gameKey: string) {
  window.open(`/admin/game-math/${encodeURIComponent(gameKey)}`, '_blank', 'noopener,noreferrer')
}
